import type { SkinLook } from "../../render/skins/looks";
import { frameElement } from "../titleFrame";
import { uiUrl } from "../portraits";
import { icon } from "../iconsKit";
import "../styles/trophyCosmetics.css";

/**
 * The Skins picker's previews for the Trophy Hall's two kinds (MP-23): a title frame on a Commander name plate (the
 * title worn now, or a sample line), and a kill effect as a short loop — a raider falls and goes out in gold coins and
 * sparkles (v2: gilded to a gold statue first), or smoulders and crumbles into embers spiralling up with curling
 * wisps — drawn in CSS (transform and opacity only; a still under reduced motion).
 */

/** The name plate the Frame tab shows its frames on. `title`: the worn Commander title, if any. */
export function framePreview(look: SkinLook, title = ""): HTMLElement {
  const d = document.createElement("div");
  d.className = "sk-tplate";
  d.innerHTML = `<div class="tp"><span class="tpi">${icon("flag", 22, "#fff8e6")}</span><div class="tpt"><b class="disp">Commander</b><small>${title || "Your title here"}</small></div></div>`;
  frameElement(d.querySelector<HTMLElement>(".tp"), look.frame ?? null);
  return d;
}

/** Particles in the loop (each placed by its index through CSS custom properties). */
const COINS = 7, SPARKS = 6, EMBERS = 12, WISPS = 4;

/** The Kill tab's loop: the raider portrait and the effect's particles (none for the plain stock look). */
export function killPreview(look: SkinLook): HTMLElement {
  const d = document.createElement("div");
  const kind = look.kill ?? "plain";
  d.className = `sk-kill k-${kind}`;
  const raider = `<img class="kr" decoding="async" src="${uiUrl("portraits/enemy_raider.png")}" alt="">`;
  // each particle's own offsets (CSS px), spread by a fixed scramble of its index so the loop looks thrown, not drawn
  const spread = (i: number, k: number, m: number) => ((i * k) % m) - (m - 1) / 2;
  const n = (count: number, cls: string) => Array.from({ length: count }, (_, i) =>
    `<i class="${cls}" style="--i:${i};--dx:${spread(i, 11, 7) * 7}px;--dy:${-((i * 37) % 50)}px;--x0:${spread(i, 29, 13) * 6}px;--y0:${-((i * 17) % 9) * 7}px"></i>`).join("");
  const fx = kind === "gilded" ? `<i class="kflash"></i>${n(COINS, "kc")}${n(SPARKS, "ks")}`
    : kind === "ember" ? `<i class="kglow"></i>${n(EMBERS, "ke")}${n(WISPS, "kw")}`
    : `<i class="kpuff"></i>`;
  // v2: the body's own beat as it falls — gilded to a gold statue, or smouldering — a tinted copy of the raider fading in over it
  const body = kind === "plain" ? "" : raider.replace('class="kr"', 'class="kr kbody"');
  d.innerHTML = `<div class="kstage"><i class="kshadow"></i>${raider}${body}${fx}</div>`;
  return d;
}
